import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import Typography from "@mui/material/Typography"

export default function CloseUnsavedTileEditorWarningDialog({ open, onClose }) {
  function handleCloseWithoutSaving() {
    onClose(CLOSE_UNSAVED_TILE_RESPONSES.cancel)
  }

  return (
    <Dialog
      open={open}
      onClose={handleCloseWithoutSaving}
      maxWidth="xs"
      fullWidth
    >
      <DialogContent>
        <Typography variant="body1">
          Changes has been made to this tile. Are you sure you want to close
          without saving?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          color="inherit"
          onClick={handleCloseWithoutSaving}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="warning"
          onClick={() => onClose(CLOSE_UNSAVED_TILE_RESPONSES.discard)}
        >
          Discard
        </Button>
        <Button
          variant="contained"
          color="success"
          onClick={() => onClose(CLOSE_UNSAVED_TILE_RESPONSES.save)}
        >
          Save tile
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export const CLOSE_UNSAVED_TILE_RESPONSES = {
  cancel: "cancel",
  discard: "discard",
  save: "save",
}
